import React from "react";
import { Modal } from "components";
import EntityForm from "modules/entity/forms";
import { Fields } from "uicomponents";
import { Field } from "formik";
import { useSelector } from "react-redux";
import useTranslation from "../../../../hooks/useTranslation";

const CreateProduct = ({ createModal, showCreateModal, cbSuccess }) => {
  const units = useSelector((state) => state.system.units);
  const { tr } = useTranslation();

  return (
    <Modal
      size={500}
      isOpen={createModal}
      toggle={() => showCreateModal(false)}
    >
      <EntityForm.Default
        method="post"
        url="/products"
        onSuccess={(data, resetForm) => {
          resetForm();
          showCreateModal(false);
          cbSuccess(data);
        }}
        params={{
          include: "unit,category",
        }}
        fields={[
          {
            name: "name",
            required: true,
          },
          {
            name: "unit_id",
            required: true,
          },
          // {
          //   name: "type",
          //   value: type,
          // },
        ]}
      >
        {({ isSubmitting, values, setFieldValue }) => {
          return (
            <div>
              <div className="modal-title">{tr("Добавить")}</div>
              <div className="modal-body">
                <Field
                  component={Fields.InputS1}
                  name="name"
                  type="text"
                  placeholder={tr("Введите наименование")}
                  label={tr("Наименование")}
                  isRequired={true}
                />

                <Field name="unit_id">
                  {({ field, form: { errors, setFieldValue, touched } }) => {
                    return (
                      <div className="form-field">
                        <label className="form-field__label">
                          {tr("Выберите Ед изм")}
                          <span title={tr("Обязательное поле")}>*</span>
                        </label>
                        <div className={"checkbox-row mb-20"}>
                          {units.map((item) => (
                            <span
                              key={item.id}
                              className={`services__item mb-5 ${field.value === item.id
                                ? "info-btn"
                                : "default-btn"
                                }`}
                              onClick={() => {
                                setFieldValue(field.name, item.id);
                              }}
                            >
                              {item.name}
                            </span>
                          ))}
                        </div>
                        {touched[field.name] && errors[field.name] && (
                          <div className="form-field__error-message">
                            <span>{tr(errors[field.name])}</span>
                          </div>
                        )}
                      </div>
                    );
                  }}
                </Field>

                <button
                  type="submit"
                  className={`d-btn d-btn-primary ${isSubmitting ? "--loading" : ""
                    }`}
                  disabled={isSubmitting}
                >
                  {tr("Добавить")}
                </button>
              </div>
            </div>
          );
        }}
      </EntityForm.Default>
    </Modal>
  );
};

export default CreateProduct;
